import React from 'react';

export default function DeleteIcon(props) {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.18059 19.499C2.72923 19.499 2.34556 19.341 2.02961 19.0251C1.71365 18.7091 1.55567 18.3255 1.55567 17.8741V2.43738H0.445312V0.812459H5.53672V0H12.6864V0.812459H17.7778V2.43738H16.6674V17.8741C16.6674 18.3074 16.5049 18.6866 16.1799 19.0115C15.855 19.3365 15.4758 19.499 15.0425 19.499H3.18059ZM15.0425 2.43738H3.18059V17.8741H15.0425V2.43738ZM6.05128 15.5451H7.6762V4.73935H6.05128V15.5451ZM10.5469 15.5451H12.1718V4.73935H10.5469V15.5451ZM3.18059 2.43738V17.8741V2.43738Z"
        fill="#DD5E27"
      />
    </svg>
  );
}
